import BasicApiFormatter from '@modules/basic-api-formatter';
import {apiNamespaces} from '@modules/constants-enumerate';
import {getApiHost} from '@epg/epg-components';

function getResourceEnumerateUrl() {
  const endpoint = '/ws/ems/0.1/json/Resource/Enumerate/';

  return getApiHost() + endpoint;
}

export default {
  apis: {
    [apiNamespaces.EMS]: {
      url: getResourceEnumerateUrl(),
      requestOptions: BasicApiFormatter.getRequestConfig(),
    },
    invalidateCache() { // This function is invoked before each get() call and it controls whether or not a cached version is returned
      return false;
    },
  }
};
